import React from 'react';
import { Grid, Box, Container, Typography, TextField, Button } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import LogoSignup from '../../../public/assets/LogoSignup.svg';
import signupIConnect from '../../../public/assets/signupIConnect.svg';
import GoogleIcon from '../../../public/assets/GoogleIcon.svg';

const validationSchema = Yup.object().shape({
    name: Yup.string()
        .min(2, 'Name must be at least 2 characters')
        .max(50, 'Name must be at most 50 characters')
        .required('*Name is required'),
    last_name: Yup.string()
        .min(2, 'Last name must be at least 2 characters')
        .max(50, 'Last name must be at most 50 characters')
        .required('*Last name is required'),
    email: Yup.string()
        .email('*Invalid email')
        .required('*Email is required'),
    phone: Yup.string()
        .matches(/^[0-9]{10}$/, '*Invalid phone number')
        .required('*Phone number is required'),
    password: Yup.string()
        .min(6, '*Password must be at least 6 characters')
        .required('*Password is required'),
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], '*Passwords must match')
        .required('*Confirm Password is required'),
});
const Signup = () => {
    const formik = useFormik({
        initialValues: {
            email: '',
            name: '',
            last_name: '',
            phone: '',
            password: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            // Handle form submission here
        },
    });

    return (
        <>
            <Grid
                container spacing={1}
                style={{
                    display: 'flex',
                    height: '100vh',
                    backgroundColor: '#F8FAFB'
                }}
            >

                <Grid item xs={7} style={{ backgroundColor: 'white', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px' }}>
                    <Box style={{ display: 'grid', justifyContent: 'center', marginTop: '50px' }}>
                        <form onSubmit={formik.handleSubmit}>
                            <Box style={{ display: 'grid' }}>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <img src={signupIConnect} alt="" style={{ width: "108px", height: "108px" }} />
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Typography style={{ fontSize: "34px", color: 'black', fontWeight: '700' }}>
                                        Sign up to your account
                                    </Typography>
                                </div>
                            </Box>

                            <Box style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                                <Box>
                                    <div>
                                        <Typography>First Name :</Typography>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            name="name"
                                            label="First Name"
                                            placeholder='Enter your first name..'
                                            sx={{ width: '337px' }}
                                            {...formik.getFieldProps('name')}

                                        />
                                        {formik.touched.name && formik.errors.name ? (
                                            <div style={{ color: 'red' }}>{formik.errors.name}</div>
                                        ) : null}
                                    </div>
                                </Box>

                                <Box>
                                    <div>
                                        <Typography>Last Name :</Typography>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <TextField
                                            fullWidth
                                            id="last_name"
                                            name="last_name"
                                            label="Last Name"
                                            placeholder='Enter your last name..'
                                            sx={{ width: '337px' }}
                                            {...formik.getFieldProps('last_name')}
                                        />
                                        {formik.touched.last_name && formik.errors.last_name ? (
                                            <div style={{ color: 'red' }}>{formik.errors.last_name}</div>
                                        ) : null}
                                    </div>
                                </Box>
                            </Box>

                            <Box style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                                <Box>
                                    <div>
                                        <Typography>Email:</Typography>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <TextField
                                            fullWidth
                                            id="email"
                                            name="email"
                                            label="Email"
                                            placeholder='Enter your email id..'
                                            sx={{ width: '337px' }}
                                            {...formik.getFieldProps('email')}
                                        />
                                        {formik.touched.email && formik.errors.email ? (
                                            <div style={{ color: 'red' }}>{formik.errors.email}</div>
                                        ) : null}
                                    </div>
                                </Box>

                                <Box>
                                    <div>
                                        <Typography>Mobile No:</Typography>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <TextField
                                            fullWidth
                                            id="phone"
                                            name="phone"
                                            label="Mobile No"
                                            placeholder='Enter your Mobile No..'
                                            sx={{ width: '337px' }}
                                            {...formik.getFieldProps('phone')}
                                        />
                                        {formik.touched.phone && formik.errors.phone ? (
                                            <div style={{ color: 'red' }}>{formik.errors.phone}</div>
                                        ) : null}                                    </div>
                                </Box>
                            </Box>

                            <Box style={{ display: 'flex', gap: '20px', marginTop: '20px' }}>
                                <Box>
                                    <div>
                                        <Typography>Password:</Typography>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <TextField
                                            fullWidth
                                            id="password"
                                            name="password"
                                            label="Password"
                                            type="password"
                                            placeholder='Enter your Password..'
                                            sx={{ width: '337px' }}
                                            {...formik.getFieldProps('password')}
                                        />
                                        {formik.touched.password && formik.errors.password ? (
                                            <div style={{ color: 'red' }}>{formik.errors.password}</div>
                                        ) : null}
                                    </div>
                                </Box>

                                <Box>
                                    <div>
                                        <Typography>Confirm Password:</Typography>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <TextField
                                            fullWidth
                                            id="confirm_password"
                                            name="confirm_password"
                                            label="Confirm Password"
                                            type="password"
                                            placeholder='Enter your Confirm Password..'
                                            sx={{ width: '337px' }}
                                            {...formik.getFieldProps('confirm_password')}
                                        />
                                        {formik.touched.confirm_password && formik.errors.confirm_password ? (
                                            <div style={{ color: 'red' }}>{formik.errors.confirm_password}</div>
                                        ) : null}
                                    </div>
                                </Box>
                            </Box>

                            <Box style={{ display: 'grid', justifyContent: 'center', marginTop: '35px', gap: '8px' }}>
                                <Box>
                                    <Button
                                        startIcon={<img src={GoogleIcon} style={{ with: '24px', height: '24px' }} />}
                                        style={{
                                            width: '305px',
                                            padding: '15px 38px',
                                            background: '#5379BD',
                                            color: 'white',
                                            borderRadius: '8px',
                                        }}>Connect with Google</Button>
                                </Box>
                                <Box style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}>
                                    <Typography>Or</Typography>
                                </Box>
                                <Box>
                                    <Button
                                        type="submit"
                                        style={{
                                            width: '305px',
                                            padding: '15px 38px',
                                            background: '#5379BD',
                                            color: 'white',
                                            borderRadius: '8px'
                                        }}>Sign up</Button>
                                </Box>

                            </Box>
                        </form>
                    </Box>

                </Grid>

                <Grid item xs={5} style={{ display: 'flex', justifyContent: 'center', backgroundColor: '#F8FAFB', }}>
                    <Box>
                        <Box style={{ marginTop: '160px', display: 'flex', justifyContent: 'center' }}>
                            <img src={LogoSignup} alt="" style={{ width: "501px", height: "402px" }} />
                        </Box>
                    </Box>
                </Grid>

            </Grid>

        </>
    )
}

export default Signup
